'use strict';

/**
 * Detect if the user is clicking/tapping and adds a special class to the body.
 * This class is used to display element :focus styles differently depending on the medium used.
 */
function detectFocusType() {
    document.body.addEventListener('mousedown', toggleFocusType);
    document.body.addEventListener('keydown', toggleFocusType);
}

function toggleFocusType(evt) {
    if (evt.type === 'mousedown') {
        this.classList.add('set--hide-click-focus');
    } else {
        this.classList.remove('set--hide-click-focus');
    }
}

export default detectFocusType;
